import $ from 'jquery';

console.log('slick-camere.js');

class carouselSliderCamere {
  constructor() {
    this.sliderCamere = $('.vetrina-camere .ecs-posts');
    this.initCarousel();
  }

  initCarousel() {
    this.sliderCamere.slick({
      autoplay: true,
      autoplaySpeed: 4000,
      infinite: true,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
      adaptiveHeight: false,
      centerMode: false,
      centerPadding: '2em',
      fade: false,
      mobileFirst: true,
      arrows: true,
      prevArrow: '<button type="button" class="slick-prev"></button>',
      nextArrow: '<button type="button" class="slick-next"></button>',
    });
  }
}

export default carouselSliderCamere;
